import { useState, useEffect } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";

export const useCoefficientData = () => {
  const [data, setData] = useState({
    coefs: [""],
    delays: [""],
    limit: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (!verifyTokenExpire()) return;

    try {
      setIsLoading(true);
      const response = await axios.get(
        `${appConfig.apiDomaine}/configurations/relance`
      );

      // On extrait correctement les tableaux reçus du backend
      const resData = response.data || {};

      setData({
        coefs: resData.coefs || (resData.coef ? [resData.coef] : [""]),
        delays: resData.delays || (resData.delai ? [resData.delai] : [""]),
        limit: resData.limit || 0,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error, refetch: fetchData };
};